module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Flip-horizontal-e5c8a5e85e3984eeb53073370e8f5d42.svg";